import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Modal } from "react-bootstrap"
import {
  resetChartSetting,
  resetAddonChart,
  resetSubChart,
  resetCycleAnaType,
  resetPriceVolumeParam,
  resetTenkankikan,
  changeAddonChart,
  changeAddonSelected,
  changeSubSelected,
  changeSubChart,
  changeTools,
  pickTarget,
  chartColorSetting,
} from "redux/ducks/Chart"
import { TOOLS, ChartColor } from "../logic/chartConfig"
import { pick, clone, remove, find, map } from "lodash"
import { colorReset } from "../logic/chartColor"

const target = [
  pick(TOOLS[1], pickTarget),
  pick(TOOLS[5], pickTarget),
  pick(TOOLS[6], pickTarget),
]

const ChartPropetyResetModal = React.memo(
  (props: { isVisible: boolean; setVisible: Function; canvasId: string }) => {
    const { isVisible, setVisible, canvasId } = props
    const colorSettingSelector = (state: any) => state.chart.colorSetting
    const toolsSelector = (state: any) => state.chart[canvasId].tools
    const termSelector = (state: any) => state.chart[canvasId].term
    const colorSetting = useSelector(colorSettingSelector)
    const tools = useSelector(toolsSelector)
    const term = useSelector(termSelector)
    const dispatch = useDispatch()

    const propetyReset = () => {
      let _tools = clone(tools)
      remove(_tools, items => {
        return !!find(target, items)
      })
      const toolsIndex = map(_tools, items => {
        return items.id
      })
      setTimeout(() => {
        const _colorSetting = clone(colorSetting)
        const newColors = new ChartColor().TechColorSetting
        colorReset(_colorSetting, newColors)
        dispatch(chartColorSetting(colorReset(_colorSetting, newColors)))
      })

      dispatch(changeTools(canvasId, toolsIndex))
      dispatch(resetAddonChart(canvasId))
      dispatch(resetSubChart(canvasId))
      dispatch(resetPriceVolumeParam(canvasId))
      dispatch(resetCycleAnaType(canvasId))
      dispatch(resetTenkankikan(canvasId))
      for (let i = 0; i < 11; i++) {
        dispatch(changeAddonChart(canvasId, [], i))
        dispatch(changeSubChart(canvasId, [], i))
      }
      dispatch(changeAddonSelected(canvasId, []))
      dispatch(changeSubSelected(canvasId, []))
      dispatch(resetChartSetting())
    }

    const onHide = () => {
      setVisible(false)
    }

    return (
      <Modal show={isVisible} dialogClassName="chart-setting-modal">
        <Modal.Header>
          <div className="header-title">初期化</div>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body-content">
            <div className="chart-propety-reset-content">
              <p>チャートのテクニカル設定を初期化します。よろしいですか？</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal-bottom-btn-row">
            <div
              className="btn btn-outline ripple"
              data-izimodal-close
              onClick={() => {
                propetyReset()
                onHide()
              }}
            >
              OK
            </div>
            <div
              className="btn btn-outline ripple"
              data-izimodal-close
              onClick={() => onHide()}
            >
              キャンセル
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
)

export default ChartPropetyResetModal
